import bookmarkIcon from "@public/img/bookmark.svg";
import bookmarkOnIcon from "@public/img/bookmark-on.svg";
import React, { useContext, useState } from "react";
import { videoService } from "@/services/video-service";
import { AppContextType, WonmovContext } from "@/context/app-context";

export default function BookmarkButton({
    movieId,
    isBookmarkedDefault,
    className,
}: {
    movieId: number;
    isBookmarkedDefault: boolean;
    className?: string;
}) {
    const { isLoggedIn } = useContext<AppContextType>(WonmovContext);
    const [isBookmarked, setIsBookmarked] = useState(isBookmarkedDefault);
    const [isLoading, setIsLoading] = useState(false);

    const handleBookmarkClick = function () {
        if (isLoading) return;
        setIsLoading(true);
        videoService.updateFavoriteStatus(movieId).then(function (response) {
            setIsLoading(false);
            if (response.status) {
                setIsBookmarked(!isBookmarked);
            }
        }).catch(function () {
            setIsLoading(false);
        });
    };

    if (!isLoggedIn) {
        return null;
    }

    var btnClass = className ? className : "size-9 rounded-sm bg-lime-400 p-1 cursor-pointer";

    return (
        <button
            type="button"
            className={btnClass}
            onClick={handleBookmarkClick}
            disabled={isLoading}
            aria-label="ذخیره فیلم"
        >
            {isLoading ? (
                <div className="loader" />
            ) : (
                <img
                    src={isBookmarked ? bookmarkOnIcon : bookmarkIcon}
                    alt=""
                />
            )}
        </button>
    );
}
